var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.hasRoleThirdParty ? _c("div", {
    class: ["third-party-selector-container", _vm.thirdPartyContainerClass]
  }, [_c("div", [_vm._v("Create an order for")]), _c("div", [_c("ThirdPartyUserSelector", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    },
    on: {
      changeUser: _vm.changeThirdPartyUserSelected
    }
  })], 1)]) : _vm._e(), _vm.pricePostingUsa.canChoose ? _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.pricePostingUsa.mustChoose && _vm.isAdminNotConsultant(_vm.loggedUserData),
      expression: "pricePostingUsa.mustChoose && isAdminNotConsultant(loggedUserData)"
    }],
    class: ["third-party-selector-container", _vm.pricePostingContainerClass]
  }, [_c("div", [_vm._v(_vm._s(_vm.pricePostingUsa.label))]), _c("div", [_c("PricePostingUsaProSelector", {
    ref: "pricePostingUsaProSelector",
    attrs: {
      loggedUserData: _vm.loggedUserData,
      isCartInProgress: _vm.isCartInProgress,
      isDisabledIfCartInProgress: _vm.pricePostingDisabledIfCartInProgress
    },
    on: {
      pricePostingChanged: _vm.changePricePostingSelected
    }
  })], 1)]) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };